import type { AxiosError } from "axios";

let endpoint = "/api/client-logs";

export function setClientLogEndpoint(apiBase: string): void {
  endpoint = `${apiBase}/client-logs`;
}

export function reportClientFailure(payload: Record<string, unknown>): void {
  try {
    const body = JSON.stringify({ page: window.location.pathname, ...payload });
    if (navigator.sendBeacon?.(endpoint, new Blob([body], { type: "application/json" }))) return;
    void fetch(endpoint, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true }).catch(
      () => undefined,
    );
  } catch {
    // Never let error reporting break the app.
  }
}

export function logApiFailure(err: AxiosError): void {
  const status = err.response?.status;
  const requestId = err.response?.headers?.["x-request-id"];
  const detail = (err.response?.data as any)?.detail ?? err.message;
  console.error(`[API] ${err.config?.method?.toUpperCase()} ${err.config?.url} -> ${status ?? err.code}`, {
    requestId,
    detail,
  });

  // Responses with a status are already logged server-side; only report failures the server never saw.
  if (!err.response) {
    reportClientFailure({
      kind: "network",
      message: err.message,
      method: err.config?.method,
      url: err.config?.url,
      detail: err.code,
    });
  }
}

export function installGlobalErrorReporting(): void {
  window.addEventListener("error", (e) => {
    reportClientFailure({ kind: "js-error", message: e.message, stack: e.error?.stack, detail: `${e.filename}:${e.lineno}` });
  });
  window.addEventListener("unhandledrejection", (e) => {
    const reason: any = e.reason;
    if (reason?.isAxiosError) return;
    reportClientFailure({ kind: "unhandled-rejection", message: String(reason?.message ?? reason), stack: reason?.stack });
  });
}
